import { Component } from "@angular/core";

@Component({
  selector: 'app-confirmation',
  standalone: false,
  templateUrl: './app-confirmation.component.html',
  styleUrl: './app-confirmation.component.scss',
  host: {
    class: 'row flex-grow-1'
  }
})
export class ConfirmationComponent {
}